<template>
  <div class="transition">
    <BasicText size="h5">Quel dispositif ?</BasicText>
    <div class="transition-items--cards">
      <BasicIconTitleCard
        @click="selectDispositif('CAPP')"
        :is-active="props.out?.code === 'CAPP'"
        icon-name="folder-add"
        :title="DispositifLibelle.CAPP"
        :disabled="!estDispositifAutorisé('CAPP')"
      />
      <BasicIconTitleCard
        @click="selectDispositif('CPRO')"
        :is-active="props.out?.code === 'CPRO'"
        icon-name="folder-add"
        :title="DispositifLibelle.CPRO"
        :disabled="!estDispositifAutorisé('CPRO')"
      />
      <BasicIconTitleCard
        @click="selectDispositif('AF')"
        :is-active="props.out?.code === 'AF'"
        icon-name="folder-add"
        :title="DispositifLibelle.AF"
        :disabled="!estDispositifAutorisé('AF')"
      />
      <!--
      <BasicIconTitleCard
        @click="selectDispositif('PROA')"
        :is-active="props.out?.code === 'PROA'"
        icon-name="folder-add"
        :title="DispositifLibelle.PROA"
        :disabled="!estDispositifAutorisé('PROA')"
      />
      -->
      <BasicIconTitleCard
        @click="selectDispositif('FPE')"
        :is-active="props.out?.code === 'FPE'"
        icon-name="folder-add"
        :title="DispositifLibelle.FPE"
        :disabled="!estDispositifAutorisé('FPE')"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
  import type { CarteEvents, CarteProps } from '@/features/interface/machine-etats/types'
  import { type Dispositif } from '@/features/domaine/types/opco'
  import { DispositifLibelle } from '@/features/application/shared'

  import type { HabilitationDispositifDTO, HabilitationsDTO } from '@/features/api/extranet/dto/Demande/shared'

  const props = defineProps<CarteProps<HabilitationsDTO, HabilitationDispositifDTO>>()
  const emits = defineEmits<CarteEvents<HabilitationDispositifDTO>>()

  const estDispositifAutorisé = (dispositif: Dispositif) => {
    return props.in.dispositifs.some((item) => item.code === dispositif)
  }

  const selectDispositif = (dispositif: Dispositif) => {
    if (props.out?.code === dispositif) {
      emits('outChanged', false)
    } else {
      const habilitations = props.in.dispositifs.find((item) => item.code === dispositif)
      emits('outChanged', true, habilitations)
    }
  }
</script>
<style lang="less" scoped>
  @import './ChoixCarte.less';

  .transition-items--cards :deep(.moduleCard--active) {
    svg g {
      fill: white;
      stroke: white;
    }
  }
</style>

